import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = {
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6 text-right" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-lg-4 offset-lg-8" }
const _hoisted_9 = { class: "input-group input-group-lg" }
const _hoisted_10 = { class: "table table-bordered table-hover table-browser mt-3" }
const _hoisted_11 = { class: "fa-stack" }
const _hoisted_12 = { class: "fa-stack" }
const _hoisted_13 = { class: "fa-stack" }
const _hoisted_14 = { class: "text-dark" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "dropdown" }
const _hoisted_18 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_19 = ["href"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReportBuilder = _resolveComponent("ReportBuilder")!
  const _component_ReportEditor = _resolveComponent("ReportEditor")!
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ReportBuilder, {
      viewModel: _ctx.reportBuilder,
      onCreateReport: _ctx.handleCreateReportCommand
    }, null, 8 /* PROPS */, ["viewModel", "onCreateReport"]),
    _createVNode(_component_ReportEditor, {
      viewModel: _ctx.reportEditor,
      onUpdateReport: _ctx.handleUpdateReportCommand
    }, null, 8 /* PROPS */, ["viewModel", "onUpdateReport"]),
    _createVNode(_component_PortfolioOrDecisionNavigation, {
      workspaceId: _ctx.workspaceId,
      projectId: _ctx.projectId
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-lg-6" }, [
          _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Reports")
        ], -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            role: "button",
            class: "btn btn-success mr-1",
            style: {"padding":"0.7em 2em"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showReportCreator && _ctx.showReportCreator(...args)))
          }, "Create report"),
          _cache[5] || (_cache[5] = _createElementVNode("a", {
            class: "btn btn-outline-secondary btn-lg",
            href: "https://www.transparentchoice.com/user-guide/reports",
            title: "User guide: Report results",
            target: "_blank"
          }, [
            _createElementVNode("i", {
              class: "fa fa-info",
              "aria-hidden": "true"
            })
          ], -1 /* CACHED */))
        ])
      ])
    ]),
    _cache[18] || (_cache[18] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_4, [
      (!_ctx.rm)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_5, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
            _createTextVNode(" Loading... ", -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true),
      (_ctx.rm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    type: "search",
                    placeholder: "Search for a report...",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.SearchPhrase) = $event))
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, _ctx.SearchPhrase]
                  ]),
                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "input-group-append" }, [
                    _createElementVNode("span", { class: "input-group-text" }, [
                      _createElementVNode("i", {
                        class: "fa-solid fa-magnifying-glass",
                        "aria-hidden": "true"
                      })
                    ])
                  ], -1 /* CACHED */))
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_10, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    class: _normalizeClass(["sortable", {'selected': _ctx.OrderBy === 'name'}]),
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.OrderByNameCommand && _ctx.OrderByNameCommand(...args)))
                  }, [
                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-uppercase font-weight-normal" }, "Name", -1 /* CACHED */)),
                    _createElementVNode("span", _hoisted_11, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fa fa-sort-asc fa-stack-1x", {'selected': (_ctx.OrderBy === 'name' && _ctx.OrderByDescending === false)}])
                      }, null, 2 /* CLASS */),
                      _createElementVNode("i", {
                        class: _normalizeClass(["fa fa-sort-desc fa-stack-1x", {'selected' : (_ctx.OrderBy === 'name' && _ctx.OrderByDescending === true)}])
                      }, null, 2 /* CLASS */)
                    ])
                  ], 2 /* CLASS */),
                  _createElementVNode("th", {
                    class: _normalizeClass(["sortable text-center", {'selected': _ctx.OrderBy === 'modified'}]),
                    style: {"width":"180px"},
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.OrderByModifiedCommand && _ctx.OrderByModifiedCommand(...args)))
                  }, [
                    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-uppercase font-weight-normal" }, "Updated on", -1 /* CACHED */)),
                    _createElementVNode("span", _hoisted_12, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fa fa-sort-asc fa-stack-1x", {'selected' : (_ctx.OrderBy === 'modified' && _ctx.OrderByDescending === false)}])
                      }, null, 2 /* CLASS */),
                      _createElementVNode("i", {
                        class: _normalizeClass(["fa fa-sort-desc fa-stack-1x", {'selected' : (_ctx.OrderBy === 'modified' && _ctx.OrderByDescending === true)}])
                      }, null, 2 /* CLASS */)
                    ])
                  ], 2 /* CLASS */),
                  _createElementVNode("th", {
                    class: _normalizeClass(["sortable text-center", {'selected': _ctx.OrderBy === 'created'}]),
                    style: {"width":"180px"},
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.OrderByCreatedCommand && _ctx.OrderByCreatedCommand(...args)))
                  }, [
                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-uppercase font-weight-normal" }, "Created on", -1 /* CACHED */)),
                    _createElementVNode("span", _hoisted_13, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fa fa-sort-asc fa-stack-1x", {'selected' : (_ctx.OrderBy === 'created' && _ctx.OrderByDescending === false)}])
                      }, null, 2 /* CLASS */),
                      _createElementVNode("i", {
                        class: _normalizeClass(["fa fa-sort-desc fa-stack-1x", {'selected' : (_ctx.OrderBy === 'created' && _ctx.OrderByDescending === true)}])
                      }, null, 2 /* CLASS */)
                    ])
                  ], 2 /* CLASS */),
                  _cache[12] || (_cache[12] = _createElementVNode("th", { style: {"width":"90px"} }, null, -1 /* CACHED */))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ReportsView, (r) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: r.ReportId
                  }, [
                    _createElementVNode("td", null, [
                      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_14, [
                        _createElementVNode("span", null, _toDisplayString(r.Name), 1 /* TEXT */)
                      ])), [
                        [_directive_sanitizedHref, _ctx.url_ReportViewPage(r.ReportId)]
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_15, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.getFormattedDateStr(r.Modified)), 1 /* TEXT */),
                      _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createElementVNode("small", null, _toDisplayString(_ctx.getFormattedTimeStr(r.Modified)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("td", _hoisted_16, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.getFormattedDateStr(r.Created)), 1 /* TEXT */),
                      _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createElementVNode("small", null, _toDisplayString(_ctx.getFormattedTimeStr(r.Created)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_17, [
                        _cache[17] || (_cache[17] = _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-secondary dropdown-toggle",
                          "data-toggle": "dropdown"
                        }, " Actions ", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            href: `/#/sharing/resource/ReportsDataShareResourceProvider/${r.ReportId}`
                          }, "Share", 8 /* PROPS */, _hoisted_19),
                          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.showReportEditor(r))
                          }, "Edit", 8 /* PROPS */, _hoisted_20),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.handleCloneReportCommand(r))
                          }, "Clone", 8 /* PROPS */, _hoisted_21),
                          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.handleDeleteReportCommand(r))
                          }, "Delete", 8 /* PROPS */, _hoisted_22)
                        ])
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}